/**
 * @param {Store}        context
 * @param {Store.commit} context.commit
 * @param {object}       error
 */
const setError = ({ commit }, error) => {
  commit('setError', error)
}

/**
 * @type {object}
 */
const actions = {
  setError
}

export default actions
